var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import "../calendar/CustomDay.css";
var formatCost = function (num) {
    if (num >= 1000) {
        // Divide by 1000 and round to one decimal place, then append 'K'
        // .toFixed(1) returns a string
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return num.toFixed(2).toString();
};
var CustomDayTimeLog = function (_a) {
    var date = _a.date, events = _a.events, onClick = _a.onClick;
    var _b = useMemo(function () {
        var isStartDay = false;
        var isEndDay = false;
        events.forEach(function (event) {
            var start = new Date(event.start);
            var end = new Date(event.end);
            // Check if event crosses midnight
            if (start.toDateString() !== end.toDateString() || end.getTime() <= start.getTime()) {
                var startDate = start.toDateString();
                var adjustedEnd = end.getTime() <= start.getTime() ?
                    new Date(end.getTime() + 24 * 60 * 60 * 1000) : end;
                var endDate = adjustedEnd.toDateString();
                // Check if this date is start or end of the shift
                if (startDate === date.toDateString()) {
                    isStartDay = true;
                }
                if (endDate === date.toDateString()) {
                    isEndDay = true;
                }
            }
        });
        var customStyle = {};
        if (isStartDay) {
            // Blue on Top, Left, Bottom. Orange on Right.
            customStyle = {
                boxShadow: "\n                    inset 1px 0 0 0 #3b82f6,   /* Left */\n                    inset 0 1px 0 0 #3b82f6,   /* Top */\n                    inset 0 -1px 0 0 #3b82f6,  /* Bottom */\n                    inset -1px 0 0 0 #fb923c   /* Right (Note: shadows can't be dashed) */\n                ",
                height: 'calc(100% - 4px)',
                paddingRight: '0.25rem'
            };
        }
        else if (isEndDay) {
            // Orange on Left. Green on Top, Right, Bottom.
            customStyle = {
                boxShadow: "\n                    inset 1px 0 0 0 #fb923c,   /* Left */\n                    inset 0 1px 0 0 #10b981,   /* Top */\n                    inset -1px 0 0 0 #10b981,  /* Right */\n                    inset 0 -1px 0 0 #10b981   /* Bottom */\n                ",
                height: 'calc(100% - 4px)',
                paddingRight: '0.25rem'
            };
        }
        var filtered = events.filter(function (event) {
            var eventDate = new Date(event.start).toDateString();
            return eventDate === date.toDateString();
        });
        var cost = filtered.reduce(function (sum, event) {
            var _a;
            var parsed = parseFloat((_a = event.content) !== null && _a !== void 0 ? _a : "");
            var value = Number.isNaN(parsed) ? 0 : parsed;
            return sum + value;
        }, 0);
        var hours = filtered.reduce(function (sum, event) {
            var _a;
            var start = new Date(event.start);
            var end = new Date(event.end);
            // if end is before or equal to start, assume it rolls over to the next day
            if (end.getTime() <= start.getTime()) {
                end = new Date(end.getTime() + 24 * 60 * 60 * 1000);
            }
            var parsed = parseFloat((_a = event.content) !== null && _a !== void 0 ? _a : "");
            if (Number.isNaN(parsed) || parsed === 0)
                return sum;
            var h = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
            return sum + h;
        }, 0);
        return {
            totalCost: cost,
            totalHours: Math.round(hours * 100) / 100, // round to 2 decimals
            borderStyle: customStyle
        };
    }, [events, date]), totalCost = _b.totalCost, totalHours = _b.totalHours, borderStyle = _b.borderStyle;
    return (_jsxs("div", { className: "flex items-start py-1 pl-1 justify-center h-full w-full rounded-md flex-col", style: __assign({}, borderStyle), onClick: onClick, children: [_jsx("span", { className: 'grow-[2] flex', style: { fontSize: '16px', paddingLeft: '2px' }, children: date.getDate().toString().padStart(2, '0') }), totalHours !== 0 && (_jsx("div", { className: "grow flex w-full mb-1", children: _jsx("span", { className: "bg-[#5898FD] text-white text-xs w-full text-center rounded-md", children: _jsx("span", { className: "text-[10px] sm:text-xs md:text-sm lg:text-base", children: "".concat(totalHours, " H") }) }) })), totalCost > 0 && (_jsx("div", { className: "grow flex w-full", children: _jsxs("span", { className: "bg-[#00A190] text-white text-xs w-full text-center rounded-md px-1", style: { fontSize: '8px' }, children: ["$", formatCost(totalCost)] }) }))] }));
};
export default CustomDayTimeLog;
